import React from 'react'
import {
  DEFAULT_LINE_WIDTH,
  SELECTED_LINE_WIDTH,
  COMMENT_LINE_TOP_OFFSET
} from '../constants'

export default function CommentLineUpward({
  annotationId,
  height,
  isSelected,
  managedTop,
  rect,
  viewportWidth,
  widthExtension
}) {
  const [[left], [right, top]] = rect

  const width = right - left

  const lineLength = viewportWidth - left - width + widthExtension

  const d = `M ${lineLength}, 1 C ${lineLength -
    lineLength * 0.5}, 1, ${lineLength * 0.5}, ${Math.abs(height) -
    1}, 0, ${Math.abs(height) - 1}`

  const normalizedHeight = Math.max(Math.abs(height), DEFAULT_LINE_WIDTH + 1)

  return (
    <div
      className="CommentLine-container"
      id={`CommentLine-container-${annotationId}`}
    >
      <svg
        className="CommentLine"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 ${lineLength} ${Math.abs(normalizedHeight)}`}
        strokeWidth={isSelected ? SELECTED_LINE_WIDTH : DEFAULT_LINE_WIDTH}
        style={{
          left: `${left + width + 6}px`,
          top: `${managedTop + COMMENT_LINE_TOP_OFFSET}px`,
          width: `${lineLength}px`,
          height: `${normalizedHeight}px`
        }}
      >
        <path d={d} stroke={'#aaaaaa'} strokeDasharray="5, 5" fill="none" />
      </svg>
    </div>
  )
}
